import React, { useEffect } from 'react';
import { X } from 'lucide-react';

const CONTENT = {
  privacy: {
    title: 'Privacy',
    body: [
      'Riva Build Group treats every enquiry with discretion. We collect only the information you choose to submit through our contact form \u2014 name, email, phone and project notes \u2014 and use it solely to respond to your enquiry and, where appropriate, to maintain a relationship with you.',
      'We do not sell, rent or share your information with third parties. Data submitted through this website is stored within Riva Build Group\u2019s internal systems and accessed only by members of our team with a legitimate business reason to do so.',
      'You may request access to, correction of, or deletion of your personal information at any time by writing to info@rivabuildgroup.com.',
    ],
  },
  terms: {
    title: 'Terms of Use',
    body: [
      'This website is provided by Riva Build Group for informational purposes only. Content, imagery and project descriptions shown here are conceptual and are not an offer to sell, lease or construct any specific property or service.',
      'All architectural renders and photographs on this site are illustrative of Riva Build Group\u2019s design direction and craft standards. Any engagement is subject to a written agreement.',
      'Riva Build Group reserves the right to modify the content of this website at any time without notice.',
    ],
  },
  licensing: {
    title: 'Licensing',
    body: [
      'Riva Build Group operates as a licensed general contractor in the State of California. Licence, bond and insurance details will be provided in writing upon qualified enquiry.',
      'We work in accordance with the regulations of the California Contractors State License Board (CSLB) and local Los Angeles building authorities, and partner only with licensed architects, engineers and trades.',
      'For verification or documentation, please contact info@rivabuildgroup.com.',
    ],
  },
};

export default function LegalModal({ kind, onClose }) {
  useEffect(() => {
    if (!kind) return;
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    const onKey = (e) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', onKey);
    return () => {
      document.body.style.overflow = prev;
      window.removeEventListener('keydown', onKey);
    };
  }, [kind, onClose]);

  if (!kind) return null;
  const c = CONTENT[kind];

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 md:p-8">
      <button
        aria-label="Close"
        onClick={onClose}
        className="absolute inset-0 bg-[#2b2a27]/60 backdrop-blur-sm"
      />
      <div className="relative w-full max-w-2xl bg-[#f4f1eb] border border-[#c9c3b6]/70 max-h-[85vh] overflow-y-auto">
        <div className="flex items-center justify-between px-6 md:px-10 py-5 border-b border-[#c9c3b6]/70">
          <div className="font-sans-ui text-[10px] tracking-[0.35em] text-[#5a5852]">
            {c.title}
          </div>
          <button
            onClick={onClose}
            aria-label="Close"
            className="p-1 -mr-1 hover:opacity-70 transition-opacity"
          >
            <X strokeWidth={1} size={20} />
          </button>
        </div>
        <div className="px-6 md:px-10 py-10">
          <h2 className="font-serif-display text-[36px] md:text-[44px] lowercase tracking-wide text-[#2b2a27] mb-8">
            {c.title.toLowerCase()}
          </h2>
          <div className="space-y-5">
            {c.body.map((p, i) => (
              <p key={i} className="text-[14px] leading-[1.9] text-[#5a5852]">
                {p}
              </p>
            ))}
          </div>
          <button
            onClick={onClose}
            className="mt-10 font-sans-ui text-[11px] tracking-[0.3em] border border-[#2b2a27] px-8 py-3 hover:bg-[#2b2a27] hover:text-[#f4f1eb] transition-colors"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
}
